<ul class="price-list">
  <li *ngFor="let plan of planList" class="plan">
    <img class="plan-img" [src]="plan.image" alt="Lighting" />
    <ng-container *ngIf="!discount else discountPriceTemplate">
      <div class="price">
        <span>{{ plan.price | number: '1.0-2' }} {{ 'subscription.plan.currency.UAH' | translate }}</span>
        <span class="price__period">{{ 'subscription.plan.month' | translate }}</span>
      </div>
    </ng-container>
    <ng-template #discountPriceTemplate>
      <div class="price">
        <s class="price__old">{{ plan.price }}</s>
        <span>{{ getPriceWithDiscount(plan.price) | number: '1.0-2' }} {{ 'subscription.plan.currency.UAH' | translate }}</span>
        <span class="price__period">{{ 'subscription.plan.month' | translate }}</span>
      </div>
    </ng-template>
    <div class="features">
      <img src="./assets/images/lighting.png" alt="Lighting" />
      <span>{{ 'subscription.plan.' + plan.name + '.count' | translate }}</span>
    </div>
    <ng-container *ngIf="currentSubscription$ | async as currentSubscription else selectPlanButtonTemplate">
      <ng-container [ngSwitch]="comparePlans(currentSubscription.plan.name, plan.name)">
        <button *ngSwitchCase="0" class="btn-main btn-primary btn-xl" [disabled]="true">
          {{ 'subscription.plan_action.current_plan' | translate }}
        </button>
        <button *ngSwitchCase="-1" class="btn-main btn-primary btn-xl" (click)="onSubscriptionPlanSelect(plan.name)">
          {{ 'subscription.plan_action.upgrade_plan' | translate }}
        </button>
        <button *ngSwitchCase="1" class="btn-main btn-secondary-purple btn-xl" (click)="onSubscriptionPlanSelect(plan.name)">
          {{ 'subscription.plan_action.downgrade_plan' | translate }}
        </button>
      </ng-container>

    </ng-container>
    <ng-template #selectPlanButtonTemplate>
      <button class="btn-main btn-primary btn-xl" (click)="onSubscriptionPlanSelect(plan.name)">
        {{ 'subscription.plan_action.select_plan' | translate }}
      </button>
    </ng-template>
  </li>

</ul>
